import type { MailboxInfo } from 'owa-client-types';
import getGlobalSettingsAccountMailboxInfo from './getGlobalSettingsAccountMailboxInfo';
import isAccountSourceListStoreInitialized from '../utils/isAccountSourceListStoreInitialized';
import { logGreyErrorFromAccounts } from 'owa-account-analytics';

/**
 * Returns the MailboxInfo for the global settings account account, if the account source list store
 * is not initialized, this will return an undefined object. This function provides a non throwing
 * way to get the global settings account mailbox info, which is useful in cases where the account
 * source list store is not initialized.
 * @returns MailboxInfo for the global settings account or undefined if the account source list store is not initialized
 */
export default function tryGetGlobalSettingsAccountMailboxInfo(
    logGreyError: boolean = true
): MailboxInfo | undefined {
    if (!isAccountSourceListStoreInitialized()) {
        // the account source list store is not initialzied, we wont be able to
        // determine if the global settings account so we return undefined.
        if (logGreyError) {
            /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
             * BASELINE: DO NOT COPY/PASTE!
             *	> Argument at index 1 for logGreyErrorFromAccounts must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
            logGreyErrorFromAccounts('NoGSA_AccountSourceListStoreNotInitialized', undefined);
        }

        return undefined;
    }

    return getGlobalSettingsAccountMailboxInfo();
}
